import React, { useState, useEffect } from 'react';
import './lib/axiosConfig';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import axios from 'axios';
import { API_BASE_URL } from './lib/constants';
import LoginPage from './pages/login';
import CurrentUserPage from './pages/current-user';
import SignUpPage from './pages/sign-up';
import ManagePage from './pages/manage';
import Dashboard from './pages/dashboard';
import Recipes from './pages/recipes';
import RecipeDetail from './pages/recipe-detail';
import RecipePrint from './pages/recipe-print';
import PrivacyPolicyPage from './pages/privacy-policy';
import TermsOfServicePage from './pages/terms-of-service';
import Home from './app/page';

function App() {
  const [googleClientId, setGoogleClientId] = useState<string>('');
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    const fetchSocialConfig = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/auth/social/config/`);
        if (response.data.google?.client_id) {
          setGoogleClientId(response.data.google.client_id);
        }
      } catch (error) {
        console.error('Failed to fetch social auth config:', error);
      } finally {
        setConfigLoaded(true);
      }
    };

    fetchSocialConfig();
  }, []);

  if (!configLoaded) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/current-user" element={<CurrentUserPage />} />
          <Route path="/sign-up" element={<SignUpPage />} />
          <Route path="/family" element={<ManagePage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/recipe/:id" element={<RecipeDetail />} />
          <Route path="/recipe/:id/print" element={<RecipePrint />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        </Routes>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App
